<template>
  <div>
    <SpFinder
      ref="finder"
      row-key="item_id"
      :split-count="10"
      url="/goods/acs/list"
      :setting="setting"
      fixed-row-action
      row-actions-fixed-align="right"
    />
    <el-dialog class="sp-picker-dialog" title="选择商品（SPU/虚拟）" :visible.sync="dialogVisible" width="1100px">
      <PickerGoodsItem ref="goods" :value="pickValue" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleGoodsSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import PickerGoodsItem from '@/components/sp-picker/pickers/picker-goodsitem'
import { tableSetting } from './config'
import { addAcsGoods } from './api'

export default {
  components: {
    PickerGoodsItem
  },
  data () {
    return {
      dialogVisible: false,
      pickValue: {
        data: [],
        multiple: true,
        rowKey: 'item_id',
        paramsFieldExclude: ['distributor_id', 'category_id'],
        queryParams: {
          is_spu: true,
          item_tier: ['acs', 'virtual_coupon']
        }
      }

    }
  },
  computed: {
    setting() {
      return tableSetting(this)
    }
  },
  methods: {
    refresh() {
      this.$refs.finder.refresh()
    },
    handleGoodsDialogShow () {
      this.dialogVisible = true
    },
    handleGoodsSubmit() {
      const { data = [] } = this.$refs.goods.getVal()
      if (data.length === 0) return this.$message.error('请选择商品')
      const item_ids = data.map(i => i.item_id).join(',')
      addAcsGoods({ item_ids }).then(res => {
        this.$message.success('添加成功')
        this.$refs.goods.updateVal([])
        this.dialogVisible = false
        this.refresh()
      })
    }
  }
}
</script>
